export const dynamicURLs = [
  '/purchase/',
  '/voucher/',
]

export function isADynamicURL(url: string): boolean {
  for (const dynURL of dynamicURLs) {
    if (url.includes(dynURL)) {
      return true
    }
  }

  return false
}
